import { ref } from 'vue';
import { messageStandardsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';
import type { ClientContext } from '~/services/contextClient';

export const useMessageStandardsGroupsCount = createGlobalState(() => {
    const groupCounts = ref<Record<number, number>>({});

    const fetching = ref(false);

    const fetchMessageStandardsGroupsCount = async (context: ClientContext, messageStandardIds: number[]) => {
        messageStandardIds = messageStandardIds.filter((messageStandardId) => !groupCounts.value[messageStandardId]);

        if (!messageStandardIds.length) {
            return;
        }

        if (fetching.value) {
            setTimeout(() => {
                fetchMessageStandardsGroupsCount(context, messageStandardIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            const response = await messageStandardsClient.getMessageStandardsGroupCounts(context, {
                custom_message_standard_ids: messageStandardIds,
            });

            messageStandardIds.forEach((messageStandardId) => {
                groupCounts.value[messageStandardId] = response.data.counts[messageStandardId] ?? 0;
            });
        } finally {
            fetching.value = false;
        }
    };

    const resetGroupCounts = () => {
        groupCounts.value = {};
        fetching.value = false;
    };

    return {
        fetchMessageStandardsGroupsCount,
        groupCounts,
        resetGroupCounts,
    };
});
